import React from 'react'
import {
  SubProductLink,
  PaidLeaveSummaryLinkTile,
  PaidLeaveSummaryLinkHeading,
  PaidLeaveSummaryLinkIcon
} from './styles'
import PAID_LEAVE from '../../constants'
import { usePaidLeave } from '../../../context/paidLeaveContext'

const PaidLeaveSummaryLinks = () => {
  const { setSelectedProduct } = usePaidLeave()
  const paidLeaveSummaryPath = '/paidLeave/summary'

  const handleLinkClick = (product) => {
    setSelectedProduct(product)
  }

  return (
    <PaidLeaveSummaryLinkTile data-testid="paid-leave-summary-links">
      <PaidLeaveSummaryLinkHeading>
        <PaidLeaveSummaryLinkIcon />
        Paid Leave Summary
      </PaidLeaveSummaryLinkHeading>
      {(PAID_LEAVE.PRODUCTS) ? PAID_LEAVE.PRODUCTS.map((subProduct, idx) => (
        <SubProductLink
          data-testid="paid-leave-summary-link-item"
          href={`${paidLeaveSummaryPath}${subProduct.productType}`}
          to={`${paidLeaveSummaryPath}${subProduct.productType}`}
          key={`${subProduct.productType}-${idx.toString()}`}
          onClick={() => handleLinkClick(subProduct)}
        >
          {subProduct.name}
        </SubProductLink>
      )) : null}
    </PaidLeaveSummaryLinkTile>
  )
}

export default PaidLeaveSummaryLinks
